module.exports = __webpack_public_path__ + "img/aeur.1e7c1382.svg";